import React, { Component } from "react";
import moment from "moment";
import {
  Modal,
  ModalBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Input,
  PopoverBody,
  PopoverHeader,
  Popover,
  Badge,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap";
import { connect } from "react-redux";
import "rc-checkbox/assets/index.css";
import "./EnterpriseObjective.css";
import axios from "../../axios";
import filter from "lodash/filter";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import size from "lodash/size";
import dot from "../../assets/dot-icon.png";
import orderBy from "lodash/orderBy";
import * as url from "../../utils/url";
import {
  LayoutHeading,
  LayoutRow,
  LayoutData,
} from "../../components/TableComponents/RowBordered/RowBordered";
import { whiteLabelStyling, wordFilter } from "../../utils/constants";

import * as actionCreators from "../../modules/actions/index";
import { capitalizeFirstLetter } from "../../utils/stringUtils";
import has from "lodash/has";
import Loading from "../../hoc/Loading/Loading";
import autosize from "autosize";
import isEmpty from "lodash/isEmpty";
import PlaceholderObjectives from "./PlaceholderObjectives";
import If from "../../components/Shared/If";
import CKEditorUI from "../../components/CKEditor/CKEditorUI";
import { objectEncode } from "../../utils/updateObject";
import PieChart from "../enterpriseAssociatedActions/ActionsPieChart.jsx";
import Activity from "../enterpriseAssociatedActions/RecentEOActivity.jsx";
import AvgCompletion from "../enterpriseAssociatedActions/AvgTaskCompletion.jsx";
import ActionCount from "../enterpriseAssociatedActions/TotalActionCount.jsx";
import UniqueActionOwners from "../enterpriseAssociatedActions/UniqueActionOwners";
import UniqueActionActivity from "../enterpriseAssociatedActions/UniqueActionActivity";
import ReactTooltip from "react-tooltip";
import { truncate } from "lodash";
import {
  BiDownArrowAlt,
  BiFilter,
  BiDetail,
  BiGitMerge,
  BiUpArrowAlt,
} from "react-icons/bi";
import Select from "react-select/lib/Select";
import PriorityContainer from "../../components/PriorityContainer/PriorityContainer";
import CreateEOModal from "./CreateEOModal";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

const errorInputText = "Enter enterprise objective destcription";
const errorInputTitleText = "Enter enterprise objective title";
const noRecordAvailable = "No records available.";

class EnterpriseObjective extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseCompleted: true,
      objectivePopoverOpen: false,
      enterpiseObjective: false,
      privacy: "PRIVATE",
      isPopupOpen: null,
      isHover: false,
      description: {
        value: "",
        error: false,
      },
      title: {
        value: "",
        error: false,
      },
      actionCount: 0,
      archiveShow: false,
      dropdownOpen: false,
      taskType: "Create",
      showToolDesc: [],
      showModal: false,
      objectiveId: "",
      modalActionType: "Create",
      allObjectives: [],
      allObjectivesCopy: [],
      selectedFilter: "",
      sortByKey: "",
      sortOrder: "",
    };
    this.EnterpriseObjectiveInput = null;
  }

  toggleDropdown = id => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  };

  createMarkup = input => {
    return { __html: `<div>${input}</div>` };
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    autosize(this.EnterpriseObjectiveInput);
    let that = this;
    let orgId = this.props.user.profile.organizationId._id;
    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      that.props.orgChangeSuccess(payload);
    });
    // Fetching all Enterprise Objectives
    // const {orgAdmin} = this.props.user.profile;
    // if(orgAdmin){
    //   this.fetchLatestData(null,false,"GET_ALL");
    // }else{
      this.fetchLatestData(null,false,"GET_ACTIVE");
    // }
  
  }

  componentWillUnmount() {
    this.props.resetObjective();
    this.props.updateFilterParams({
      filterBy:""
    })
  }

  // componentDidUpdate(prevProps,nextState){
  //     if(JSON.stringify(this.state.allObjectives) !== JSON.stringify(nextState.allObjectives)){

  //     }
  // }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      );
    }

    if (
      JSON.stringify(this.props.filterParams) !==
      JSON.stringify(nextProps.filterParams)
    ) {
      this.handleFilterChange(nextProps.filterParams.filterBy);
    }
  }



  changeTaskCount = val => {
    // console.log('change actionCount!')
    this.setState(prevState => ({
      actionCount: prevState.actionCount + val,
    }));
  };

  fetchLatestData = (cb, isRun, type) => {
    const { profile } = this.props.user;
    const { orgAdmin } = profile;

    axios
      .get(`${url.getEnterpriseObjectives}/${profile.organizationId._id}${type=="GET_ACTIVE"?"?removeDeleted=true":""}`)
      .then(({ data }) => {
        // console.log(data.data.taskList)

        let tempData = data.data.taskList.map(item => ({
          ...item,
        }));

        if (!orgAdmin) {
          tempData = tempData.filter(itm => !itm.isDeleted);
        }

        if(type==="GET_ARCHIVED"){
          tempData = tempData.filter(itm => itm.isDeleted);
        }
        if(type==="GET_ALL"){
          tempData = tempData;
        }
        this.setState({
          allObjectives: [...tempData],
          allObjectivesCopy: [...tempData],
        });

        // setTimeout(() => {
        //   const { sortParams, filterParams } = this.props;
        //   if (filterParams.filterBy) {
        //     this.handleFilterChange(filterParams.filterBy);
        //   }
        //   if (sortParams.sortBy && sortParams.sortOrder) {
        //     this.handleSortChange(sortParams.sortBy, sortParams.sortOrder);
        //   }
        // }, 500);

        this.props.onFetchEnterpriseObjectives(data.data.taskList);
        if (isRun) {
          let val = type == "remove" ? -1 : 1;

          if(cb){
            cb(val);

          }
        }
      });
  };

  archieveObjective = objectiveId => {
    axios.put(`${url.archiveObjective}/${objectiveId}`).then(() => {
      this.fetchLatestData(this.changeTaskCount, true, "remove");
    });
  };

  unarchieveObjective = objectiveId => {
    axios.put(`${url.unarchiveObjective}/${objectiveId}`).then(() => {
      this.fetchLatestData(this.changeTaskCount, true, "add");
    });
  };

  handleChangeObjectiveDescription = event => {
    const descriptionContext = event.editor.getData();
    this.setState({ description: { value: descriptionContext } });
  };

  handleChangeObjectiveTitle = event => {
    const { value } = event.target;
    this.setState({ title: { value: value } });
  };

  handleSubmitObjective = () => {
    const { description, title, privacy, taskType, objectiveId } = this.state;
    let desc = description.value.replace(/<\/?[^>]+(>|$)/g, "");
    let d_string = description.value.replace(/^\s+|\s+$/g, "");

    if (desc.length > 0 && title.value.length > 0) {
      if (taskType === "Update") {
        let payload = {
          description: d_string,
          title: title.value,
          privacy,
          _id: objectiveId,
        };
        axios
          .post(url.updateEnterpriseObjective, objectEncode(payload))
          .then(({ data }) => {
            this.fetchLatestData();
          });
      } else {
        let payload = {
          description: d_string,
          title: title.value,
          privacy,
        };
        axios
          .post(url.addEnterpriseObjective, objectEncode(payload))
          .then(({ data }) => {
            const newObjective = data.data;
            // const allObjArray = [...this.state.allObjectives];
            this.state.allObjectives.unshift(newObjective);
            // this.state.allObjectivesCopy.unshift(newObjective);
            //this.fetchLatestData();
          });
      }
      this.setState({ showModal: false, description: "", title: "" });
    }
  };
  toggle = id => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  };

  toggleEnterpriseModal = (description, title, objectiveId, actionType) => {
    this.setState({
      modalActionType: actionType,
      showModal: !this.state.showModal,
      description: {
        ...this.state.description,
        value: description,
        error: false,
      },
      title: {
        ...this.state.title,
        value: title,
        error: false,
      },
      objectiveId,
      taskType: actionType,
    });
  };

  closeAddEnterprise = () => {
    this.setState({
      showModal: false,
    });
  };

  closeEnterpriseAddModal = () => {
    this.setState({
      showModal: false,
    });
  };

  renderGreeting = () => {
    const currentHour = moment().hour();
    const { profile } = this.props.user;
    let greeting = "";
    if (currentHour >= 0 && currentHour < 12) {
      greeting = "Good Morning";
    } else if (currentHour >= 12 && currentHour < 18) {
      greeting = "Good Afternoon";
    } else {
      greeting = "Good Evening";
    }
    return (
      <span>
        {greeting}, {capitalizeFirstLetter(profile.firstName)}
      </span>
    );
  };

  redirectToAssociatedActions = objectiveId => {
    this.props.history.push(
      `/home/enterprise-associatedActions/${objectiveId}`
    );
  };

  toggleLegend = () => {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  };

  renderEnterpriseObjectives = list => {
    const { collapse } = this.state;
    const { orgAdmin } = this.props.user.profile;
    list = orderBy(list, ["createdOn"], ["desc"]);

    if (list && list.length > 0) {
      return list.map((item, index) => (
        <div key={index} className="col-lg-6 col-md-6">
          <div
            className="weekly-wins-objectives pink-bg d-flex flex-wrap entObjectiveContainerList"
            style={whiteLabelStyling(
              ["backgroundColor", "borderColor"],
              this.props.user.profile.organizationId
            )}
          >
            <div className="todo-content-wrapper align-self-start">
              <div className="enterpriseObjectivesTitleContainer">
                {item.title}
              </div>
              {(item.createdOn && item.createdOn != null) ||
              (item.lastUpdate && item.lastUpdate) ? (
                <div className="todo-item-date mt10">
                  created on{" "}
                  <span className="dateLabel">
                    {moment(
                      item.lastUpdate !== undefined
                        ? item.lastUpdate
                        : item.createdOn
                    ).format("MMM D, YYYY h:mm a")}
                  </span>
                </div>
              ) : null}

              <div className="link-unlink-wrapper">
                <div
                  className="link-unlink enterpriseName"
                  onClick={() => this.redirectToAssociatedActions(item._id)}
                >
                  {`Linked Actions (${item.taskCounter})`}
                </div>

                <span className="divider">|</span>
                <div
                  className="link-unlink enterpriseName"
                  onClick={() => this.redirectToAssociatedActions(item._id)}
                >
                  See Details
                </div>
              </div>
            </div>

            <If condition={orgAdmin}>
              <Dropdown
                isOpen={this.state.dropdownOpen === item._id ? true : false}
                toggle={() => this.toggleDropdown(item._id)}
                className="wwDropdown"
              >
                <DropdownToggle
                  tag="span"
                  className="chart-item-menu"
                  onClick={() => this.toggleDropdown(item._id)}
                  data-toggle="dropdown"
                  aria-expanded={
                    this.state.dropdownOpen === item._id ? true : false
                  }
                >
                  <i
                    className="chart-item-menu flaticon-menu-1"
                    style={{ cursor: "pointer" }}
                  ></i>
                </DropdownToggle>
                <DropdownMenu
                  right
                  className="chart-dropdown"
                  style={{ padding: "0" }}
                >
                  <div
                    className="chart-list-dropdown-options"
                    style={{ display: "flex" }}
                    // onClick={() => this.editTask(todo)}
                  >
                    <i className="chart-item-menu flaticon-edit"></i>
                    <span
                      className="chart-list-dropdown-options-text"
                      onClick={() =>
                        this.toggleEnterpriseModal(
                          item.description,
                          item.title,
                          item._id,
                          "Update"
                        )
                      }
                    >
                      Edit
                    </span>
                  </div>
                  <div
                    className="chart-list-dropdown-options"
                    style={{ display: "flex" }}
                    onClick={() => this.archieveObjective(item._id)}
                  >
                    <i className="chart-item-menu flaticon-trash"></i>
                    <span className="chart-list-dropdown-options-text">
                      Archive
                    </span>
                  </div>
                </DropdownMenu>
              </Dropdown>
            </If>
          </div>
        </div>
      ));
    }
    return (
      <div className="col-lg-6 col-md-6">
        <div>
          <div className="todo-content-wrapper align-self-start mt20">
            {noRecordAvailable}
          </div>
        </div>
      </div>
    );
  };

  renderArchiveObjectives = list => {
    if (list && list.length > 0) {
      return list.map((item, index) => (
        <div key={index} className="col-lg-6 col-md-6">
          <div
            className="weekly-wins-objectives pink-bg d-flex flex-wrap enterpriseAction"
            style={whiteLabelStyling(
              ["backgroundColor", "borderColor"],
              this.props.user.profile.organizationId
            )}
          >
            <div className="todo-content-wrapper align-self-start">
              <div className="todo-item-title">{item.title}</div>
              <div className="todo-item-date mt10">
                <span className="dateLabel">
                  {moment(
                    item.lastUpdate !== undefined
                      ? item.lastUpdate
                      : item.createdOn
                  ).format("MMM D, YYYY")}
                </span>
              </div>
              <div className="link-unlink-wrapper">
                <div
                  className="link-unlink enterpriseName"
                  onClick={() => this.redirectToAssociatedActions(item._id)}
                >
                  {`Linked Actions (${item.taskCounter})`}
                </div>
              </div>
            </div>

            <Dropdown
              isOpen={this.state.dropdownOpen === item._id ? true : false}
              toggle={() => this.toggleDropdown(item._id)}
              className="wwDropdown"
            >
              <DropdownToggle
                tag="span"
                className="chart-item-menu"
                onClick={() => this.toggleDropdown(item._id)}
                data-toggle="dropdown"
                aria-expanded={
                  this.state.dropdownOpen === item._id ? true : false
                }
              >
                <i
                  className="chart-item-menu flaticon-menu-1"
                  style={{ cursor: "pointer" }}
                ></i>
              </DropdownToggle>
              <DropdownMenu
                right
                className="chart-dropdown"
                style={{ padding: "0" }}
              >
                <div
                  className="chart-list-dropdown-options"
                  onClick={() => this.redirectToAssociatedActions(item._id)}
                >
                  See Details
                </div>

                <div
                  className="chart-list-dropdown-options"
                  onClick={() => this.unarchieveObjective(item._id)}
                >
                  Restore
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      ));
    }
    return null;
  };

  handleCollapse = () => {
    this.setState(state => ({
      collapseCompleted: !state.collapseCompleted,
      archiveShow: !state.archiveShow,
    }));
  };

  togglePopup = val => {
    let { isPopupOpen } = this.state;
    if (val == isPopupOpen) {
      this.setState({ isPopupOpen: null });
    } else {
      this.setState({ isPopupOpen: val });
    }
  };

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    });
  };

  sortComponent = key => {
    const { sortParams } = this.props;
    if (
      JSON.stringify(sortParams.sortBy) === JSON.stringify(key) &&
      sortParams.sortOrder === "asc"
    ) {
      return (
        <BiDownArrowAlt
          size={"22px"}
          onClick={() => this.changeSortField(key, "desc")}
        />
      );
    } else {
      return (
        <BiUpArrowAlt
          size={"22px"}
          onClick={() => this.changeSortField(key, "asc")}
        />
      );
    }
  };

  handleSortChange = (key, order) => {
    let objectives = [...this.state.allObjectives];
    switch (key) {
      default:
        objectives = orderBy(objectives, itm => itm[key], [order]);
        break;
    }
    this.setState({ allObjectives: objectives });
  };

  handleFilterChange = e => {
    const isOrgAdmin = this.props.user && this.props.user.profile && this.props.user.profile.orgAdmin
    if (e) {
      switch (e) {
        case "ARCHIVED":
          this.fetchLatestData(null, true, "GET_ARCHIVED");
          break
        case "ACTIVE":
          this.fetchLatestData(null, true, "GET_ACTIVE");
          break
        case "ALL":
          if(isOrgAdmin){
            this.fetchLatestData(null, true, "GET_ALL");
          }else{
            this.fetchLatestData(null, true, "GET_ACTIVE");
          }
          break

        default:
          this.fetchLatestData(null, true, "GET_ACTIVE");
          break

      }
    } else {
      this.fetchLatestData(null, true, "GET_ACTIVE");
    }
  };

  handleUpdateInTable = task => {
    const allOrgIndex = this.state.allObjectives.findIndex(
      itm => itm._id === task._id
    );
    if (allOrgIndex > -1) {
      const allTodoArr = [...this.state.allObjectives];
      allTodoArr[allOrgIndex] = { ...allTodoArr[allOrgIndex], ...task };
      this.setState({ allObjectives: allTodoArr });
    }

    const allOrgCopyIndex = this.state.allObjectivesCopy.findIndex(
      itm => itm._id === task._id
    );
    if (allOrgCopyIndex > -1) {
      const allTodoArr = [...this.state.allObjectivesCopy];
      allTodoArr[allOrgCopyIndex] = { ...allTodoArr[allOrgCopyIndex], ...task };
      this.setState({ allObjectivesCopy: allTodoArr });
    }
  };

  handlePriorityChange = task => {
    axios
      .post(url.updateEnterpriseObjective, objectEncode(task))
      .then(({ data }) => {
        const newTask = data.data;
        this.handleUpdateInTable(newTask);
      })
      .catch(err => console.log(err));
  };

  handleAppendObjInTable = newObjective => {
    this.state.allObjectives.unshift(newObjective);
    this.state.allObjectivesCopy.unshift(newObjective);
    this.closeEnterpriseAddModal();
  };

  handleUpdateObjInTable = data => {
    const index = this.state.allObjectives.findIndex(x => x._id == data._id);

    if (index >= 0) {
      const allArr = [...this.state.allObjectives];
      allArr[index] = data;

      this.setState({ allObjectives: allArr });
    }

    const indexC = this.state.allObjectives.findIndex(x => x._id == data._id);

    if (indexC >= 0) {
      const allArrC = [...this.state.allObjectivesCopy];
      allArrC[indexC] = data;

      this.setState({ allObjectivesCopy: allArrC });
    }

    this.closeEnterpriseAddModal();
  };
  render() {
    let {
      description,
      title,
      collapseCompleted,
      allObjectives,
      archiveObjectives,
      archiveShow,
      actionCount,
    } = this.state;
    const { orgAdmin } = this.props.user.profile;
    const { objectives } = this.props;
    const isOrgAdmin = this.props.user && this.props.user.profile && this.props.user.profile.orgAdmin

    const filterOptions = [
      
      {
        value: "ACTIVE",
        label: "Active",
      },
      {
        value: "ALL",
        label: "All",
      },
    ];

    if(isOrgAdmin){
      filterOptions.unshift({
        value: "ARCHIVED",
        label: "Archived",
      })
    }

    const title_col = 3,
      date_col = 2,
      linked_col = 2,
      desc_col = 4,
      status_col = 1,
      priority_col = 1;

    const { sortParams, filterParams } = this.props;

    console.log({filterParams})

    return (
      <div className="enterprise-obj enterpriseObjectivesListContainer col-md-12">
        <div className="weekly-wins-greeting-text">{this.renderGreeting()}</div>
        <div className="weekly-wins-supporting-text">
          <span>
          Make your workplace more welcoming and supportive by taking daily actions.
          </span>
        </div>

        <div className="enterpriseStatsContainer">
          <div className="allStatsRow">

            <div className="enterprisePieChart col-sm-6 col-md-4">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <span
                    className="ml10"
                    id="actionStatus"
                    onClick={() => this.togglePopup(5)}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="left"
                    isOpen={this.state.isPopupOpen == 5 ? true : false}
                    target="actionStatus"
                    toggle={() => this.togglePopup(5)}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Action Status
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Snapshot of progress on actions that are linked with an
                      objective, indicated as: not started, in progress, or
                      completed.
                    </PopoverBody>
                  </Popover>
                </span>

                <span className="enterpriseObjTitle">Action Status</span>
                <span className="enterpriseObjSubtitle">
                  across all objectives
                </span>

                <PieChart actionCount={actionCount} eo_id={null} />
              </span>
            </div>

            <div className="enterprisePieChart col-md-4 enterpriseObj-grid-stats">
                <div className="enterpriseActionCount">
                  <span className="singleStatContainer">
                    <span className="entObjHelpIcon">
                      <span
                        className="ml10"
                        id="uniqueUsers"
                        onClick={() => this.togglePopup(1)}
                      >
                        <Tooltip />
                      </span>
                      <Popover
                        placement="left"
                        isOpen={this.state.isPopupOpen == 1 ? true : false}
                        target="uniqueUsers"
                        toggle={() => this.togglePopup(1)}
                      >
                        <PopoverHeader className="popover-header-tooltip">
                          Unique Users
                        </PopoverHeader>
                        <PopoverBody className="popover-body-tooltip">
                          Total number of unique users who have created or been
                          assigned an action which may be private, public or linked with an
                          objective.
                        </PopoverBody>
                      </Popover>
                    </span>
                    <span className="enterpriseObjTitle">Unique Users</span>
                    <span className="enterpriseObjSubtitle">
                      across all actions
                    </span>
                    <UniqueActionOwners actionCount={actionCount} eo_id={null} />
                  </span>
                </div>

                <div className="enterpriseActionCount">
                  <span className="singleStatContainer">
                    <span className="entObjHelpIcon">
                      <span
                        className="ml10"
                        id="actionEngagement"
                        onClick={() => this.togglePopup(2)}
                      >
                        <Tooltip />
                      </span>
                      <Popover
                        placement="left"
                        isOpen={this.state.isPopupOpen == 2 ? true : false}
                        target="actionEngagement"
                        toggle={() => this.togglePopup(2)}
                      >
                        <PopoverHeader className="popover-header-tooltip">
                          Actively Engaged
                        </PopoverHeader>
                        <PopoverBody className="popover-body-tooltip">
                        Percentage of users with actions who have made at least one update on the platform to their action which may be private, public or linked with an objective.
                        </PopoverBody>
                      </Popover>
                    </span>
                    <span className="enterpriseObjTitle">Actively Engaged</span>
                    <span className="enterpriseObjSubtitle">
                      users across all actions
                    </span>
                    <UniqueActionActivity actionCount={actionCount} eo_id={null} />
                  </span>
                </div>

                <div className="enterpriseActionCount">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <span
                    className="ml10"
                    id="totalActions"
                    onClick={() => this.togglePopup(4)}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="left"
                    isOpen={this.state.isPopupOpen == 4 ? true : false}
                    target="totalActions"
                    toggle={() => this.togglePopup(4)}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Total Actions
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Total number of actions that have been linked with all
                      objectives.
                    </PopoverBody>
                  </Popover>
                </span>

                <span className="enterpriseObjTitle">Total Actions</span>
                <span className="enterpriseObjSubtitle">
                  towards all objectives
                </span>
                <ActionCount actionCount={actionCount} eo_id={null} />
              </span>
                </div>

                <div className="enterpriseActionCount">
                  <span className="singleStatContainer">
                    <span className="entObjHelpIcon">
                      <span
                        className="ml10"
                        id="avgCompletion"
                        onClick={() => this.togglePopup(6)}
                      >
                        <Tooltip />
                      </span>
                      <Popover
                        placement="left"
                        isOpen={this.state.isPopupOpen == 6 ? true : false}
                        target="avgCompletion"
                        toggle={() => this.togglePopup(6)}
                      >
                        <PopoverHeader className="popover-header-tooltip">
                          Average Completion
                        </PopoverHeader>
                        <PopoverBody className="popover-body-tooltip">
                          Average progress of all actions that are linked with
                          objectives.
                        </PopoverBody>
                      </Popover>
                    </span>
                    <span className="enterpriseObjTitle">Average Completion</span>
                    <span className="enterpriseObjSubtitle">
                      of all objectives 
                      {/* towards objectives */}
                    </span>
                    <AvgCompletion actionCount={actionCount} eo_id={null} />
                  </span>
                </div>
            </div>

            <div className="enterprisePieChart col-sm-6 col-md-4">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <span
                    className="ml10"
                    id="actionActivity"
                    onClick={() => this.togglePopup(3)}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="left"
                    isOpen={this.state.isPopupOpen == 3 ? true : false}
                    target="actionActivity"
                    toggle={() => this.togglePopup(3)}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Activity
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                    Timeline of updates made by users to all actions which may be private, public or linked with an objective.
                    </PopoverBody>
                  </Popover>
                </span>

                <span className="enterpriseObjTitle">Activity</span>
                <span className="enterpriseObjSubtitle">
                  {" "}
                  across all actions{" "}
                </span>
                <Activity
                  actionCount={actionCount}
                  eo_id={null}
                  xAxisByMonth={true}
                />
              </span>
            </div>
         
         
          </div>

          {/* <div className="objectivesRow">
            <div className="enterpriseActionCount col-sm-6 col-md-4">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <span
                    className="ml10"
                    id="totalActions"
                    onClick={() => this.togglePopup(4)}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="left"
                    isOpen={this.state.isPopupOpen == 4 ? true : false}
                    target="totalActions"
                    toggle={() => this.togglePopup(4)}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Total Actions
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Total number of actions that have been linked with all
                      objectives.
                    </PopoverBody>
                  </Popover>
                </span>

                <span className="enterpriseObjTitle">Total Actions</span>
                <span className="enterpriseObjSubtitle">
                  towards all objectives
                </span>
                <ActionCount actionCount={actionCount} eo_id={null} />
              </span>
            </div>

            <div className="enterpriseActionCount col-sm-6 col-md-4">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <span
                    className="ml10"
                    id="avgCompletion"
                    onClick={() => this.togglePopup(6)}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="left"
                    isOpen={this.state.isPopupOpen == 6 ? true : false}
                    target="avgCompletion"
                    toggle={() => this.togglePopup(6)}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Average Completion
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Average progress of all actions that are linked with
                      objectives.
                    </PopoverBody>
                  </Popover>
                </span>
                <span className="enterpriseObjTitle">Average Completion</span>
                <span className="enterpriseObjSubtitle">
                  of all actions towards objectives
                </span>
                <AvgCompletion actionCount={actionCount} eo_id={null} />
              </span>
            </div>

            <div className="enterprisePieChart col-sm-6 col-md-4">
              <span className="singleStatContainer">
                <span className="entObjHelpIcon">
                  <span
                    className="ml10"
                    id="actionStatus"
                    onClick={() => this.togglePopup(5)}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="left"
                    isOpen={this.state.isPopupOpen == 5 ? true : false}
                    target="actionStatus"
                    toggle={() => this.togglePopup(5)}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Action Status
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Snapshot of progress on actions that are linked with an
                      objective, indicated as: not started, in progress, or
                      completed.
                    </PopoverBody>
                  </Popover>
                </span>

                <span className="enterpriseObjTitle">Action Status</span>
                <span className="enterpriseObjSubtitle">
                  across all objectives
                </span>

                <PieChart actionCount={actionCount} eo_id={null} />
              </span>
            </div>
          </div> */}

        </div>

        {this.state.showModal && (
          <CreateEOModal
            showModal={this.state.showModal}
            taskType={this.state.modalActionType}
            title={this.state.title}
            description={this.state.description}
            closeEnterpriseAddModal={this.closeEnterpriseAddModal}
            objectiveId={this.state.objectiveId}
            fetchLatestData={this.fetchLatestData}
            handleAppendObjInTable={this.handleAppendObjInTable}
            handleUpdateObjInTable={this.handleUpdateObjInTable}
          />
        )}

        {/*<Modal isOpen={this.state.showModal}>
          <ModalBody style={{ padding: "30px" }}>
            <div className="row">
              <div className="weeklyWinTitle pick-office-modal-body-title">{`${this.state.modalActionType} an Enterprise Objective`}</div>
            </div>
            <span className="addTaskHeaders">Title</span>
            <div className="inner-addon right-addon">
              <span className="name-hint-max-length name-char-count-txt">{`${size(
                title.value
              )}/64`}</span>
              <Input
                type="text"
                name="objectiveTitle"
                onChange={this.handleChangeObjectiveTitle}
                value={title.value}
                maxLength={64}
              />
            </div>

            <div className="addTaskHeaders mt20">Description</div>
            <CKEditorUI
              onChange={this.handleChangeObjectiveDescription}
              value={description.value}
            />
            <div style={{ padding: "10px 0px 0px 0px" }}>
              <Button
                className="profile-modal-save-btn float-left weeklyWinBtn"
                onClick={this.handleSubmitObjective}
                disabled={isEmpty(description.value && title.value)}
              >
                <span className="profile-modal-save-btn-txt">
                  Create<span className="ml10 flaticon-tick"></span>
                </span>
              </Button>
              <Button
                className="profile-modal-cancel-btn float-right weeklyWinBtn"
                onClick={this.closeEnterpriseAddModal}
              >
                <span className="profile-modal-cancel-btn-txt">Cancel</span>
              </Button>
            </div>
          </ModalBody>
        </Modal>*/}

        <div className="actions-table-div mt-1">
          <Row>
            <Col lg={9} md={9}>
              <If condition={orgAdmin}>
                <Button
                  onClick={() =>
                    this.toggleEnterpriseModal("", "", "", "Create")
                  }
                  color="primary"
                >
                  Create an Enterprise Objective
                </Button>
              </If>
            </Col>
            <Col lg={3} md={3}>
              <InputGroup>
                <InputGroupAddon
                  addonType="prepend"
                  className={"ig_prepend_icon"}
                >
                  <InputGroupText className={"actions-filter-prepend"}>
                    <BiFilter size={"20px"} />
                  </InputGroupText>
                </InputGroupAddon>
                <div style={{ width: "80%" }}>
                  <Select
                    options={filterOptions}
                    isOpen={true}
                    name="office-select"
                    isClearable={false}
                    className="react-select-no-border"
                    placeholder="Filters"
                    onChange={e => {
                      console.log(e);
                      if (e) {
                        this.props.updateFilterParams({
                          filterBy: e.value,
                        });
                      } else {
                        this.props.updateFilterParams({
                          filterBy: "",
                        });
                      }
                    }}
                    value={filterParams.filterBy}
                  />
                </div>
              </InputGroup>
            </Col>
          </Row>

          <div className="mt-3">
            <If condition={size(allObjectives) > 0}>
              {/*{this.renderEnterpriseObjectives(allObjectives)}*/}
              <div id="ouroffice-objectives-layout" className="bg-white">
                <LayoutRow>
                  <LayoutHeading
                    className="p-2 border border-grey"
                    colWidth={title_col}
                  >
                    Objective Title {this.sortComponent("title")}
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-2 border border-grey"
                    colWidth={date_col}
                  >
                    Created On {this.sortComponent("createdOn")}
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-2 border border-grey"
                    colWidth={linked_col}
                  >
                    Linked Actions {this.sortComponent("taskCounter")}{" "}
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-2 border border-grey"
                    colWidth={desc_col}
                  >
                    Description
                  </LayoutHeading>
                  <LayoutHeading
                    className="p-2 border border-grey"
                    colWidth={status_col}
                  >
                    Status
                  </LayoutHeading>
                  {/* <LayoutHeading  className="p-2 border border-grey"colWidth={priority_col}>
                    Priority
                  </LayoutHeading> */}
                </LayoutRow>
                {allObjectives.map((item, index) => {
                  return (
                    <LayoutRow className={`pl-tasks-row `}>
                      <LayoutData colWidth={title_col}>
                        {" "}
                        <div className="objective-title-layout-div">
                          {item.isDeleted ? (
                            <div>
                              <i
                                className="chart-item-menu flaticon-menu-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.toggleDropdown(item._id)}
                                id={`Popover1${item._id}`}
                              ></i>
                              <Popover
                                target={`Popover1${item._id}`}
                                isOpen={
                                  this.state.dropdownOpen === item._id
                                    ? true
                                    : false
                                }
                                toggle={() => this.toggleDropdown(item._id)}
                                className=""
                              >
                                <PopoverBody
                                  className={"bg-dark popover-items"}
                                >
                                  <div
                                    className="chart-list-dropdown-options"
                                    onClick={() =>
                                      this.redirectToAssociatedActions(item._id)
                                    }
                                  >
                                    See Details
                                  </div>
                                  <If condition={orgAdmin}>
                                    <div
                                      className="chart-list-dropdown-options"
                                      onClick={() =>
                                        this.unarchieveObjective(item._id)
                                      }
                                    >
                                      Restore
                                    </div>
                                  </If>
                                </PopoverBody>
                              </Popover>
                            </div>
                          ) : (
                            <If condition={true}>
                              <i
                                className="chart-item-menu flaticon-menu-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.toggleDropdown(item._id)}
                                id={`Popover1${item._id}`}
                              ></i>
                              <Popover
                                target={`Popover1${item._id}`}
                                isOpen={
                                  this.state.dropdownOpen === item._id
                                    ? true
                                    : false
                                }
                                toggle={() => this.toggleDropdown(item._id)}
                                className=""
                              >
                                <PopoverBody
                                  className={"bg-dark popover-items"}
                                >
                                  <If condition={orgAdmin}>
                                    <div
                                      className="chart-list-dropdown-options"
                                      style={{ display: "flex" }}
                                      // onClick={() => this.editTask(todo)}
                                    >
                                      <i className="chart-item-menu flaticon-edit"></i>
                                      <span
                                        className="chart-list-dropdown-options-text"
                                        onClick={() =>
                                          this.toggleEnterpriseModal(
                                            item.description,
                                            item.title,
                                            item._id,
                                            "Update"
                                          )
                                        }
                                      >
                                        Edit
                                      </span>
                                    </div>
                                  </If>

                                  <If condition={orgAdmin}>
                                    <div
                                      className="chart-list-dropdown-options"
                                      onClick={() =>
                                        this.archieveObjective(item._id)
                                      }
                                    >
                                      {" "}
                                      <i className="chart-item-menu flaticon-trash"></i>
                                      Archive
                                    </div>
                                  </If>
                                  <div
                                    className="chart-list-dropdown-options"
                                    onClick={() =>
                                      this.redirectToAssociatedActions(item._id)
                                    }
                                  >
                                    See Details
                                  </div>
                                </PopoverBody>
                              </Popover>
                            </If>
                          )}{" "}
                          <div
                            className="objective-title-layout cursor-pointer"
                            data-tip={item.title}
                            onClick={() =>
                              this.redirectToAssociatedActions(item._id)
                            }
                          >
                            {item.title} <ReactTooltip />
                          </div>
                        </div>{" "}
                      </LayoutData>

                      <LayoutData colWidth={date_col}>
                        <div className="objective-data-text">
                          {moment(item.createdOn).format("MMM D, YYYY")}
                        </div>
                      </LayoutData>
                      <LayoutData colWidth={linked_col} className="px-2">
                        <div className="linked-actions-content-wrapper">
                          <span
                            className="objective-linked-actions-chip cursor-pointer"
                            onClick={() =>
                              this.redirectToAssociatedActions(item._id)
                            }
                          >
                            {item.taskCounter}{" "}
                            <BiGitMerge
                              size={"16px"}
                              className="font-weight-bold"
                            />
                          </span>
                        </div>
                      </LayoutData>
                      <LayoutData colWidth={desc_col}>
                        <div className="objective-data-text px-1">
                          {item.description.length > 0 &&
                            ReactHtmlParser(
                              truncate(
                                item.description.replace(/<(.|\n)*?>/g, ""),
                                {
                                  length: 120,
                                }
                              )
                            )}
                        </div>
                      </LayoutData>
                      <LayoutData colWidth={status_col}>
                        {item.isDeleted ? (
                          <Badge
                            pill
                            className={"badge-small-text"}
                            color={"danger"}
                          >
                            Archived
                          </Badge>
                        ) : (
                          <Badge
                            pill
                            className={"badge-small-text"}
                            color={"success"}
                          >
                            Active
                          </Badge>
                        )}
                      </LayoutData>
                    </LayoutRow>
                  );
                })}
              </div>
            </If>
            <If condition={size(allObjectives) <= 0}>
              <PlaceholderObjectives />
            </If>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
    objectives: state.enterpriseObjective.objectives,
    sortParams: state.sortFilterParams.objectives.sort,
    filterParams: state.sortFilterParams.objectives.filter,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchEnterpriseObjectives: data =>
      dispatch(actionCreators.storeEnterpriseObjectives(data)),
    orgChangeSuccess: data => dispatch(actionCreators.orgChangeSuccess(data)),
    resetObjective: () => dispatch(actionCreators.resetEnterpriseObjectives()),
    updateSortParams: data =>
      dispatch(actionCreators.updateObjectivesSort(data)),
    updateFilterParams: data =>
      dispatch(actionCreators.updateObjectivesFilter(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(EnterpriseObjective, axios));
